export default __webpack_public_path__ + "static/media/enable-solid.c5e219c0.svg";